export default "__VITE_ASSET__B9aMx4Vq__"